<template>
  <footer
    class="article-note"
    :class="wrapperClass"
  >
    <ArticleNoteItem
      v-for="item of notes"
      :key="item.id"
      :text="item.text"
      :url="item.url"
      :description="item.description"
    />
    <ArticleNoteItem
      class="typo-info"
      description=""
      text="Если нашли ошибку, выделите текст и нажмите Ctrl + Enter"
    />
  </footer>
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  import ArticleNoteItem from '~/components/ArticleNoteItem.amp.vue';

  import type { TArticleNoteItem } from '~/types';
  import { ADS_LABELS } from '~/constants/ads-labels';
  export default defineNuxtComponent({
    name: 'ArticleNote',

    components: {
      ArticleNoteItem,
    },

    props: {
      notes: {
        type: Array as PropType<Array<TArticleNoteItem>>,
        required: true,
      },
      isPromo: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      wrapperClass(): Record<string, boolean> {
        return {
          promo: this.isPromo,
        };
      },
    },
  });

  // TODO: Функция используется для трансформации пропсов в родительском компоненте.
  // Рефакторинг без экспорта функции из компонента.
  // Вынести в utils или преобразовывать объект внутри компонента после получения.
  export const getArticleNoteProps = (
    source?: IArticleMeta['source'],
    caption?: IArticleMeta['cover_source'],
    customAuthors?: string,
    customAuthorsDescription: string = 'Над текстом работали: ',
    adsSource?: { url: string; text: string },
    isAdvertising?: boolean,
    isPromo?: boolean,
    advertLabel?: string,
  ): Array<TArticleNoteItem> => {
    const arr = [];

    if (isAdvertising || isPromo) {
      const label = isPromo ? 'ads' : advertLabel || '';
      if (adsSource?.text || adsSource?.url) {
        const text = adsSource.text || adsSource.url;
        const description = ADS_LABELS[label] || '';
        arr.push({
          id: Symbol(),
          text,
          url: adsSource.url,
          description: description.length ? `${description}: ` : '',
        });
      } else {
        arr.push({
          id: Symbol(),
          text: ADS_LABELS[label],
          url: '',
          description: '',
        });
      }
    }

    if (caption && caption.text) {
      arr.push({
        id: Symbol(),
        description: 'Обложка: ',
        text: caption.text,
        url: caption.url,
      });
    }

    if (source && source.text) {
      arr.push({
        id: Symbol(),
        description: 'Источник: ',
        text: source.text,
        url: source.url,
      });
    }

    if (customAuthors) {
      arr.push({
        id: Symbol(),
        description: customAuthorsDescription,
        text: customAuthors,
      });
    }

    return arr;
  };
</script>
<style lang="scss" scoped>
  $borderColor: #e7e7e7;
  .article-note {
    @include amp {
      margin-top: 32px;
    }
  }

  .promo {
    text-align: center;

    &.notes {
      margin-bottom: 0px;
    }

    :deep() {
      .item:nth-last-child(2) {
        padding-bottom: 0px;
        border-bottom: none;

        @include tablet {
          padding-bottom: 8px;
        }
      }
    }

    .typo-info {
      border-top: none;
      padding: 0;
    }
  }
</style>

<style lang="scss">
  .article-note .item {
    a {
      @include linkTinyStyle;
    }
  }
</style>
